module.exports = __webpack_public_path__ + "img/boschw.e1b9cd34.svg";